import { render, staticRenderFns } from "./WorksView.vue?vue&type=template&id=3e21d970"
import script from "./WorksView.vue?vue&type=script&lang=js"
export * from "./WorksView.vue?vue&type=script&lang=js"
import style0 from "./WorksView.vue?vue&type=style&index=0&id=3e21d970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports